import { render, staticRenderFns } from "./data-list.vue?vue&type=template&id=1ff12f8c&"
import script from "./data-list.vue?vue&type=script&lang=js&"
export * from "./data-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports